import axios from "axios";
import config from "../../config";
import { RiskSearchResult } from "./types/risk-search-response";
import { RiskSearchRequest } from "./types/risk-search-request";

const apiUrl = config.api;

export const getRiskSearchResults = async (
  searchRequestData: RiskSearchRequest,
): Promise<RiskSearchResult> => {
  const response = await axios.post<RiskSearchResult>(
    `${apiUrl}/search`,
    searchRequestData,
  );

  return response.data;
};

export default getRiskSearchResults;
